import React, { Fragment } from "react";
import { Card, Row, Col, Button } from 'react-bootstrap';
import '../../../../../styles/leis-auth.scss'

const Lei = (props) => {
   return (
        <Fragment>
            <Col>
            <p>{props.lei.categoria} Nº{props.lei.num_lei}</p><br/>
            </Col>
        </Fragment >)
}

export default Lei;